import { useState } from 'react';
import { Header } from 'shared/components/organisms/Header/Header';
import { Sidebar } from 'shared/components/organisms/Sidebar/Sidebar';

import { RevenueTag } from 'shared/components/molecules/RevenueTag/RevenueTag';
import { FileInput } from 'shared/components/molecules/FileInput/FileInpunt';

import {
  AttendanceCard,
  Banner,
  BannerWrapper,
  Container,
  Content,
  Docs,
  Overlay,
  Profile,
  ProfileSection,
  Toogle,
  Wellcome,
  WellcomeRow,
} from './_homeDemo';
import { useHistory } from 'react-router';

export const HomeDemo = () => {
  const history = useHistory();
  const [document, setDocument] = useState<File>();
  const [toggleActive, setToggleActive] = useState<boolean>(false);
  const [showMessage, setShowMessage] = useState<boolean>(false);

  return (
    <Container>
      <Header />
      <Sidebar />

      <Content>
        <WellcomeRow>
          <Wellcome>
            <span className="wellcome__message">
              Seja bem vindo
              <strong className="wellcome__message__strong"> Prestador!</strong>
            </span>

            <p className="wellcome__message__description">
              Atenda à solicitações dos clientes e acompanhe seu faturamento em
              tempo real!
            </p>
          </Wellcome>

          <RevenueTag />
        </WellcomeRow>
      </Content>

      <ProfileSection>
        <Content>
          <div className="profile-section__first-row">
            <div className="profile__wrapper">
              <Profile>
                <span className="profile__title">
                  Seu perfil profissional: ---
                </span>
              </Profile>

              <Docs>
                <span className="docs__title">Envio de documentação</span>

                <span className="docs__feedback">
                  Status da documentação - Pendente
                </span>

                <FileInput
                  inputText="Enviar Documentação"
                  inputFile={document}
                  setInputFile={setDocument}
                />
              </Docs>
            </div>

            <AttendanceCard>
              <span className="attendance-card__title">
                Meus atendimentos - Fechado
              </span>
              Nesta modalidade, as solicitações de chamado não aparecerão para
              você
              <Toogle>
                <div
                  className={`toogle__wrapper ${toggleActive ? 'active' : ''}`}
                  onClick={() => setToggleActive(!toggleActive)}
                >
                  <div
                    className={`toogle__wrapper__pin
                  ${toggleActive ? 'pin-active' : ''}`}
                  ></div>
                </div>
              </Toogle>
              <span className="attendance-card__closing-indicator">
                Loja Fechada desde: <strong>--/--/---- ás --:--</strong>
              </span>
            </AttendanceCard>
          </div>

          <BannerWrapper>
            <Banner>
              <span>
                Profissionais de qualidade <strong> é na Repfy</strong>
              </span>
            </Banner>
            <div className="hex"></div>
          </BannerWrapper>
        </Content>
      </ProfileSection>

      <Overlay
        onClick={() => setShowMessage(!showMessage)}
        active={showMessage}
      >
        <div
          className={`overlay__message-wrapper ${
            showMessage ? 'show-message' : ''
          }`}
        >
          <div
            className="overlay__message__button"
            onClick={() => history.push('cadastro')}
          >
            Cadastre-se para utilizar o aplicativo
          </div>

          <span>
            Ou se você já é cadastrado{' '}
            <strong onClick={() => history.push('login')}> faça login</strong>{' '}
            para continuar
          </span>
        </div>
      </Overlay>
    </Container>
  );
};
